export const DEFAULT_PAGE_SIZE = 50;

/** Maximum source page units requested in unpaged mode; post-cap embedded expansion may yield more rows. */
export const UNPAGED_MAX_RECORDS = 5000;

export function currentPageReportTemplate(params: { currentPage: number, total: number, pageTotal: number, isFiltered?: boolean, module?: string }): string {

    const { total, pageTotal, isFiltered, currentPage, module } = params

    if (total === 0 && pageTotal === 0)
        return 'No results found';

    const filterApplied = isFiltered ? ' - Filter Applied' : '';
    return `Page ${currentPage} of ${pageTotal} (${total} ${module}${filterApplied})`;
}
